import { deleteEmptyObj, formatCST } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 10,
  activeTab: '0',
  schoolName: '',
  teacherName: '',
  area: [],
  created_at_from: null,
  created_at_to: null,
  sort_type: ''
}

const actions = {
  // 获取学校数据
  async enterSchoolGetData ({ state, commit }, payload) {
    const data = {
      name: state.schoolName,
      real_name: state.teacherName,
      sort_type: state.sort_type,
      country_id: state.area[0] ? '156' : '',
      province_id: state.area[0],
      city_id: state.area[1],
      district_id: state.area[2],
      created_at_from: state.created_at_from && formatCST(state.created_at_from),
      created_at_to: state.created_at_to && formatCST(state.created_at_to)
    }
    deleteEmptyObj(data)
    const url = state.activeTab === '0' ? '/edu/zone/channel/agent/school/unit/list' : '/edu/zone/channel/agent/school/teacher/list'
    const res = await API.post(`${url}?page=${state.page}&limit=${state.limit}`, data)
    commit('setState', {
      module: 'enterSchool',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 查看学校详情
  async viewSchoolDetail ({ state }, id) {
    const res = await API.post(`/edu/zone/channel/agent/school/unit/${id}/view`)
    return res
  },
  // 获取作品数量
  async getWorkCount ({ state }, payload) {
    const res = await API.post(`/edu/zone/channel/agent/school/work/count`, payload)
    return res
  },
  // 获取教师的作品统计
  async getTeacherWorkCount ({ state }, payload) {
    const res = await API.post(`/edu/zone/channel/agent/school/teacher/statistical/data`, payload)
    return res
  }
}

const mutations = {
  enterSchoolInit (state) {
    state.page = 1
    state.total = 0
    state.limit = 10
    state.schoolName = ''
    state.teacherName = ''
    state.area = []
    state.created_at_from = null
    state.created_at_to = null
    state.sort_type = ''
  }
}

export default {
  state,
  actions,
  mutations
}
